import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { Category, categoryType } from '../../types/slices/categoryType'

const initialState: categoryType =
{
    status: ApiStatus.FETCHED,
    categories: [],
    categoriesWithProducts : [],
    categorySelected: {} as Category,
    errorMessage: undefined,
    action: ''
}

const categorySilce = createSlice({
    name: 'categorySilce',
    initialState,
    reducers: {
        onFetchCategories (state, { payload }: { payload: Category[]}) {
            state.status = ApiStatus.FETCHED
            state.categories = payload
            state.errorMessage = undefined
        },
        onFetchCategoriesWithProduct (state, { payload }: { payload: Category[]}) {
            state.status = ApiStatus.FETCHED
            state.categoriesWithProducts = payload
            state.errorMessage = undefined
        },
        onSetSelectedCategory (state, { payload }: { payload: Category }) {
            state.categorySelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
            state.action = payload
        },
    }
})

export const selectCategoryState = (state: RootState) => state.categorySilce
export default categorySilce.reducer
export const {
    onFetchCategories,
    onFetchCategoriesWithProduct,
    onSetSelectedCategory,
    changeStatus,
    setAction,
} = categorySilce.actions
